import { AxiosResponse } from 'axios';
import { getAxiosSecureInstance } from '../../utilities/AxiosClient';

export interface ReportField {
  id: string;
}

export interface ReportStep {
  id: string;
  fields: ReportField[];
}

export interface ReportContent {
  name: string;
  steps: ReportStep[];
  general?: ReportField[];
}

export interface Report {
  id: string;
  formId: string;
  content: ReportContent;
  culture: string;
}

export function getReportById(organizationId: string, formId: string, reportId: string): Promise<AxiosResponse> {
  return getAxiosSecureInstance().get(`/api/organizations/${organizationId}/forms/${formId}/reports/${reportId}`);
}

export function getReportsByFormId(organizationId: string, formId: string): Promise<AxiosResponse> {
  return getAxiosSecureInstance().get(`/api/organizations/${organizationId}/forms/${formId}/reports`);
}

export function generateReport(organizationId: string, formId: string, report: Report): Promise<AxiosResponse> {
  const axios = getAxiosSecureInstance();
  return axios.request({
    responseType: 'arraybuffer',
    url: `/api/organizations/${organizationId}/forms/${formId}/reports/generate`,
    data: report,
    method: 'post',
  });
}

export function createReport(organizationId: string, formId: string, report: Report): Promise<AxiosResponse> {
  return getAxiosSecureInstance().post(`/api/organizations/${organizationId}/forms/${formId}/reports`, report);
}

export function updateReport(organizationId: string, formId: string, report: Report): Promise<AxiosResponse> {
  return getAxiosSecureInstance().post(
    `/api/organizations/${organizationId}/forms/${formId}/reports/${report.id}`,
    report,
  );
}

export function deleteReport(organizationId: string, formId: string, reportId: string): Promise<AxiosResponse> {
  return getAxiosSecureInstance().delete(`/api/organizations/${organizationId}/forms/${formId}/reports/${reportId}`);
}
